import { render, staticRenderFns } from "./BoletinPeriodoJulius.vue?vue&type=template&id=785f1fc6&scoped=true&"
import script from "./BoletinPeriodoJulius.vue?vue&type=script&lang=js&"
export * from "./BoletinPeriodoJulius.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785f1fc6",
  null
  
)

export default component.exports